import { render, staticRenderFns } from "./EmojiItem.vue?vue&type=template&id=cf9ae01e&scoped=true&"
import script from "./EmojiItem.vue?vue&type=script&lang=js&"
export * from "./EmojiItem.vue?vue&type=script&lang=js&"
import style0 from "./EmojiItem.vue?vue&type=style&index=0&id=cf9ae01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9ae01e",
  null
  
)

export default component.exports